import 'core-js/es6/map';
import 'core-js/es6/set';

import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import App from './components/AppContainer';
import './index.scss';
import reducer from './redux/modules';

if (typeof window !== 'undefined' && window.rexButtons && window.rexButtons.length) {
  const uniqueChecks = {};
  const rexButtons = window.rexButtons;

  /* eslint-disable no-underscore-dangle */
  const store = createStore(reducer, {}, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
  /* eslint-enable no-underscore-dangle */

  for (let i = 0; i < rexButtons.length; i += 1) {
    const el = document.getElementById(rexButtons[i].id);

    if (el) {
      ReactDOM.render(
        <Provider store={store}>
          <App rexButton={rexButtons[i]} shouldCheck={!Object.hasOwnProperty.call(uniqueChecks, rexButtons[i].cId)} />
        </Provider>,
        el
      );
    }

    if (!Object.hasOwnProperty.call(uniqueChecks, rexButtons[i].cId)) {
      uniqueChecks[rexButtons[i].cId] = 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/index.js